// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  getServiceStatistics,
  getKnowledgeSourceStatus,
  createKnowledgeSource,
  listKnowledgeSources,
  getKnowledgeSource,
  deleteKnowledgeSource,
  createOrUpdateKnowledgeSource,
  createKnowledgeBase,
  listKnowledgeBases,
  getKnowledgeBase,
  deleteKnowledgeBase,
  createOrUpdateKnowledgeBase,
  createAlias,
  listAliases,
  getAlias,
  deleteAlias,
  createOrUpdateAlias,
  analyzeText,
  getIndexStatistics,
  createIndex,
  listIndexesWithSelectedProperties,
  listIndexes,
  getIndex,
  deleteIndex,
  createOrUpdateIndex,
  createSynonymMap,
  getSynonymMaps,
  getSynonymMap,
  deleteSynonymMap,
  createOrUpdateSynonymMap,
} from "./operations.js";
export type {
  GetServiceStatisticsOptionalParams,
  GetKnowledgeSourceStatusOptionalParams,
  CreateKnowledgeSourceOptionalParams,
  ListKnowledgeSourcesOptionalParams,
  GetKnowledgeSourceOptionalParams,
  DeleteKnowledgeSourceOptionalParams,
  CreateOrUpdateKnowledgeSourceOptionalParams,
  CreateKnowledgeBaseOptionalParams,
  ListKnowledgeBasesOptionalParams,
  GetKnowledgeBaseOptionalParams,
  DeleteKnowledgeBaseOptionalParams,
  CreateOrUpdateKnowledgeBaseOptionalParams,
  CreateAliasOptionalParams,
  ListAliasesOptionalParams,
  GetAliasOptionalParams,
  DeleteAliasOptionalParams,
  CreateOrUpdateAliasOptionalParams,
  AnalyzeTextOptionalParams,
  GetIndexStatisticsOptionalParams,
  CreateIndexOptionalParams,
  ListIndexesWithSelectedPropertiesOptionalParams,
  ListIndexesOptionalParams,
  GetIndexOptionalParams,
  DeleteIndexOptionalParams,
  CreateOrUpdateIndexOptionalParams,
  CreateSynonymMapOptionalParams,
  GetSynonymMapsOptionalParams,
  GetSynonymMapOptionalParams,
  DeleteSynonymMapOptionalParams,
  CreateOrUpdateSynonymMapOptionalParams,
} from "./options.js";
export type { SearchIndexContext, SearchIndexClientOptionalParams } from "./searchIndexContext.js";
export { createSearchIndex } from "./searchIndexContext.js";
